
export default {
  name: 'RandomLetterPicker',
  data () {
    return {
      data: '',
      form: this.$vform({
        numbers: 1,
        cases: 'uppercase'
      })
    }
  },
  methods: {
    onRandomLetterPicker() {
        this.form.post(`/tool/random-letter-picker`, { progress: false }).then(res => {
          this.data = Object.values(res.data);
        }).catch(e => {
          console.log(e);
        });
    },
    formatLetters(data) {
      return data.flat().join('\n');
    },
    onSample(){
        this.form.numbers = 1;
    },
    onReset(){
        this.form.reset();
        this.data = '';
    },
    copyToClipboard() {
      document.getElementById("text").select();
      document.execCommand('copy');
    }
  }
}
